<template>
  <div class="modal fade" :id="modalId" tabindex="-1" aria-hidden="true" ref="modalRef">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-body text-center p-4">
          <!-- Icon -->
          <div class="mb-4">
            <div class="rounded-circle bg-warning-subtle d-inline-flex align-items-center justify-content-center" style="width: 80px; height: 80px;">
              <vue-feather type="alert-circle" size="40" class="text-warning"></vue-feather>
            </div>
          </div>

          <!-- Title -->
          <h4 class="mb-2">{{ title }}</h4>

          <!-- Message -->
          <p class="text-muted mb-4">{{ message }}</p>

          <!-- Current Plan Info -->
          <div v-if="currentPlan" class="bg-light rounded p-3 mb-4 text-start">
            <div class="d-flex justify-content-between align-items-center mb-2">
              <span class="text-muted">Current Plan</span>
              <span class="badge bg-secondary">{{ currentPlan }}</span>
            </div>
            <div class="d-flex justify-content-between align-items-center">
              <span class="text-muted">{{ resourceLabel }}</span>
              <span class="fw-semibold">{{ used }} / {{ limit }}</span>
            </div>
          </div>

          <!-- Actions -->
          <div class="d-flex gap-2 justify-content-center">
            <button type="button" class="btn btn-primary px-4" @click="goToUpgrade">
              <vue-feather type="zap" size="16" class="me-1"></vue-feather>
              Upgrade Plan
            </button>
            <button type="button" class="btn btn-light px-4" data-bs-dismiss="modal">
              Maybe Later
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Modal } from 'bootstrap';

export default {
  name: 'UpgradeModal',

  props: {
    modalId: {
      type: String,
      default: 'upgradeModal'
    },
    title: {
      type: String,
      default: 'Upgrade Required'
    },
    message: {
      type: String,
      default: 'You have reached your plan limit. Upgrade to unlock more features.'
    },
    currentPlan: {
      type: String,
      default: ''
    },
    resourceLabel: {
      type: String,
      default: 'Usage'
    },
    used: {
      type: [Number, String],
      default: 0
    },
    limit: {
      type: [Number, String],
      default: 0
    }
  },

  data() {
    return {
      modalInstance: null
    };
  },

  mounted() {
    this.modalInstance = new Modal(this.$refs.modalRef);
  },

  methods: {
    show() {
      this.modalInstance?.show();
    },

    hide() {
      this.modalInstance?.hide();
    },

    goToUpgrade() {
      this.hide();
      this.$router.push('/owner/subscription');
    }
  }
};
</script>

<style scoped>
.bg-warning-subtle {
  background-color: #fff3cd;
}
</style>

<style>
body.dark-only .bg-warning-subtle {
  background-color: rgba(255, 193, 7, 0.15) !important;
}
</style>
